export const CUSTOMISATION_HALF_CARD_TEST_IDS = {
    REPEAT: `CUSTOMISE_HALF_CARD_REPEAT`,
    I_WILL_CHOOSE: `CUSTOMISE_HALF_CARD_I_WILL_CHOOSE`,
};
